
































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IWorkflowForSelection } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'EntityWorkflowSelectedSingle',

  props: {
    workflow: {
      type: Object as () => IWorkflowForSelection,
      required: true,
    },
    showSelected: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    hasJobs(workflow: IWorkflowForSelection): boolean {
      return workflow.listJobs.length > 0
    },
  },
})
